import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv,ButtonContent } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import AlertCircleWarning from 'src/assets/images/AlertCircleWarning.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const UnsavedChanges = ({
    onClose,
    onDiscard,
    continueText,
    fromSettingsClose,
    fromPriceOverride,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup
                title={
                    fromPriceOverride
                        ? t('consignmentBilling.common.notifications.popUp')
                        : t('consignmentBilling.common.notifications.popUp1')
                }
                onClose={fromSettingsClose ? fromSettingsClose : onClose}
                img={
                    fromPriceOverride ? AlertCircleWarning : AlertCircleOutline
                }
                id={'consignmentBilling-common-unsavedChanges-popup'}
                isUnsavedPage={true}
            >
                <UnsavedChangesDiv divHeight={'140px'}>
                    <Text
                        flexGrow={'1'}
                        height={'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                    >
                        {fromPriceOverride
                            ? t('consignmentBilling.common.notifications.text')
                            : t(
                                'consignmentBilling.common.notifications.text1'
                            )}
                    </Text>
                    <DesktopWrap flexDirection="row-reverse">
                        <Button
                            id={'consignmentBilling-unsavedChanges-continueButton'}
                            show={true}
                            width={'308px'}
                            height={'38px'}
                            variant={ButtonStyles.primary}
                            margin={'5px 0 5px 5px'}
                            clicked={onClose}
                        >
                            <ButtonContent>
                                {continueText
                                    ? continueText
                                    : t(
                                        'consignmentBilling.common.notifications.continueEditing'
                                    )}
                            </ButtonContent>
                        </Button>

                        <Button
                            id={'consignmentBilling-unsavedChanges-discardButton'}
                            show={true}
                            variant={ButtonStyles?.discard}
                            width={'320px'}
                            height={'38px'}
                            margin={'5px'}
                            clicked={onDiscard}
                        >
                            <ButtonContent>
                                {t(
                                    'consignmentBilling.common.notifications.discardChangesAndExit'
                                )}
                            </ButtonContent>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default UnsavedChanges;
